import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fxRevaluations, type FxRevaluationListItem } from '@/api/fxRevaluations';
import DataTable, { type ColumnDef } from '@/shared/components/DataTable';

const fmt2 = (v: string | number) =>
  Number(v).toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function FxRevaluationsPage() {
  const navigate = useNavigate();
  const list = useQuery({
    queryKey: ['fx-revaluations'],
    queryFn: () => fxRevaluations.list({ limit: 200 }),
  });

  const cols = useMemo<ColumnDef<FxRevaluationListItem>[]>(() => [
    { key: 'document_number', header: '№', width: 150, sortValue: (r) => r.document_number ?? '', cell: (r) => r.document_number },
    {
      key: 'document_date', header: 'Дата документа', width: 170,
      sortValue: (r) => r.document_date ?? '',
      cell: (r) => r.document_date ? new Date(r.document_date).toLocaleString('uk-UA') : '',
    },
    {
      key: 'revaluation_date', header: 'Дата переоцінки', width: 160,
      sortValue: (r) => r.revaluation_date ?? '',
      cell: (r) => r.revaluation_date ? new Date(r.revaluation_date).toLocaleDateString('uk-UA') : '',
    },
    {
      key: 'total_income', header: 'Доходи', width: 140, align: 'right',
      sortValue: (r) => Number(r.total_income),
      cell: (r) => <span style={{ color: '#15803d' }}>{fmt2(r.total_income)}</span>,
    },
    {
      key: 'total_expense', header: 'Витрати', width: 140, align: 'right',
      sortValue: (r) => Number(r.total_expense),
      cell: (r) => <span style={{ color: '#b91c1c' }}>{fmt2(r.total_expense)}</span>,
    },
    {
      key: 'posted', header: 'Проведено', width: 130, align: 'center',
      sortValue: (r) => r.posted ? 1 : 0,
      cell: (r) => r.posted ? '✓ так' : 'ні',
    },
  ], []);

  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>Переоцінка валюти (курсові різниці)</h2>
        <button className="primary" onClick={() => navigate('/fx-revaluations/new')}>
          + Нова переоцінка
        </button>
      </div>
      <DataTable<FxRevaluationListItem>
        rows={list.data?.items ?? []}
        columns={cols}
        rowKey={(r) => r.id}
        loading={list.isLoading}
        emptyText="Немає документів."
        onRowDoubleClick={(r) => navigate(`/fx-revaluations/${r.id}`)}
        rowMuted={(r) => r.deletion_mark ? 0.4 : undefined}
        initialSortKey="document_date"
        initialSortDir="desc"
      />
    </>
  );
}
